import React from 'react';

import Typography from '@mui/material/Typography';
import DialogTitle, { dialogTitleClasses, DialogTitleProps } from '@mui/material/DialogTitle';
import IconButton, { iconButtonClasses } from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

export interface ClosableDialogTitleProps extends DialogTitleProps {
    onClick?: (ev: React.MouseEvent<HTMLElement>) => void;
}

const PaddedDialogTitle = styled(DialogTitle)((/*{ theme }*/) => ({
    [`& .${dialogTitleClasses.root}`]: {
        margin: "0",
        padding: "16px 24px",
    },
}));

const CloseIconButton = styled(IconButton)(({ theme }) => ({
    [`&.${iconButtonClasses.root}`]: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function ClosableDialogTitle({ children, onClick, ...other }: Readonly<ClosableDialogTitleProps>): JSX.Element {
    return <PaddedDialogTitle {...other}>
        {
            children ? (
                <Typography component="div" variant="h6">
                    {children}
                </Typography>
            ) : null
        }
        {
            onClick && (
                <CloseIconButton aria-label="close" onClick={onClick} size="large">
                    <CloseIcon />
                </CloseIconButton>
            )
        }
    </PaddedDialogTitle>
}

export default ClosableDialogTitle;